import React, { Component } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { applyDataTable } from "../../../../custom/dataTable";
import Save from "../../../../../assets/img/svg/save.svg";
import Cancel from "../../../../../assets/img/svg/cancel.svg";
import FilterIcon from "../../../../../assets/img/svg/FilterIcon.svg";
import del from "../../../../../assets/img/svg/Del.svg";
import View from "../../../../../assets/img/svg/view.svg";
import { CodeSharp, ExpandLess, ExpandMore } from "@material-ui/icons";
import download from "../../../../../assets/img/svg/DownloadIcon.svg";
import Autocomplete from "react-autocomplete";
import { useNavigate } from "react-router-dom";
import Pagination from "../../../../custom/Pagination";
import { Tabs, Tab, AppBar, Box } from "@material-ui/core";
import $ from "jquery";
import {
  TextField,
  FormControlLabel,
  Radio,
  Checkbox,
  Select,
  MenuItem,
  InputBase,
  Chip,
  Input,
  Button,
  InputAdornment,
  IconButton,
  FormHelperText,
  FormControl,
  RadioGroup,
} from "@material-ui/core";
import withRouter from "../../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import styles from "../../../../../assets/jss/customStyle";
import { withStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import moment from "moment";
import axios from "axios";
import active from "../../../../../assets/img/svg/active.svg";
import deactive from "../../../../../assets/img/svg/deactive.svg";
import API from "../../../../../_helpers/endpointService";
import { getSettingsFormat } from "../../../../../actions/SettingsAction";

import {
  CssTextField,
  CssTextFieldLast,
  CssTextFieldTons,
} from "../../../../custom/textField";
const useStyles = makeStyles((theme) => ({
  button: {
    background: "#FFFFFF",
    border: "none",
    boxSizing: "border-box",
    borderRadius: "7px",
    padding: "5px 10px",
  },
}));
const style = {};
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

class ListViewDISWC extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
      isError: false,
      decimal: 0.0,
      more: true,
      value: 0,
      isAccess: false,
      TotalWeightBlocks: 0,
      SectionData: {
        Id: 0,
        ProjectId: 0,
        DrawingId: 0,
        DismantlingId: 0,
        SectionId: 0,
        Tons: 0.0,
        Total: 0,
      },
      totalWeight: true,
      ProjectId: 0,
      Blocks: [],
      MoreID: 0,
      Modify: "",
      data: {
        Id: 0,
        ProjectId: 0,
        DismantlingId: 0,
        Remarks: "",
        drawingId: 0,
      },
      BlockData: {
        Id: 0,
        ProjectId: 0,
        DrawingId: 0,
        Remark: "",
        DismantlingId: 0,
        Total: 0,
      },
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    this.state.Modify = localStorage.getItem("UserRoles");
    this.state.BlockData.ProjectId = parseInt(localStorage.getItem("DashId"));
    this.state.SectionData.ProjectId = parseInt(localStorage.getItem("DashId"));
    this.setState({});
    if (this.state.Modify === "Admin" || this.state.Modify === "Supervisor") {
      this.setState({
        isAccess: true,
      });
    }
    this.props.dispatch(getSettingsFormat(this.state.ProjectId));
    this.gethistorylog(this.state.BlockData.ProjectId);
    this.getBlock(this.state.BlockData.ProjectId);
    this.interval = setInterval(() => {
      this.resize();
    }, 10);
  }
  componentWillUnmount() {
    clearInterval(this.interval);
    $("#WEIGHT1 .MuiListItemText-primary").addClass("spanTopBar");
    $("#Disweight1 .MuiListItemText-primary").removeClass("fw-bolder");
    $("#Disweight").addClass("d-none");
    $("#Disweight").removeClass("d-block");
    $("#DWCL").removeClass("active-color");
    $("#DWCT").removeClass("fw-bolder");
  }
  handleChange = (event, newValue) => {
    this.setState({
      value: newValue,
    });
    if (newValue == 1) {
      this.gethistorylog(this.state.BlockData.ProjectId);
    }
  };
  resize = () => {
    if (window.innerWidth < 850) {
      this.setState({
        isMobile: true,
      });
    } else {
      this.setState({
        isMobile: false,
      });
    }
    $("#WEIGHT1 .MuiListItemText-primary").addClass("spanTopBar");
    $("#Disweight1 .MuiListItemText-primary").addClass("fw-bolder");
    $("#Disweight").removeClass("d-none");
    $("#Disweight").addClass("d-block");
    $("#DWCL").addClass("active-color");
    $("#DWCT").addClass("fw-bolder");
    this.state.Blocks = this.props.weight;
    this.setState({});
  };
  sidebar = () => {
    this.props.navigate("/sidebar");
  };
  getBlock = (id) => {
    let apiUrl = API.WEIGHTCALCULATION + id;
    this.props.dispatch({ type: "SHOW_LOADER", data: true });
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        if (response?.status === 200) {
          this.props.dispatch({
            type: "WEIGHT_CALCULATION",
            data: response.data,
          });
          this.setState({
            Blocks: response.data,
          });
          this.state.Blocks?.mappedweights.map((i) => {
            i.more = true;
          });
          this.setState({});
        } else {
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
      });
  };
  getBlock1 = (id) => {
    let apiUrl = API.WEIGHTCALCULATION + id;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          this.props.dispatch({
            type: "WEIGHT_CALCULATION",
            data: response.data,
          });

          this.setState({
            Blocks: response.data,
          });
          if (this.state.MoreID != 0) {
            this.state.Blocks?.mappedweights.map((i) => {
              if (i.DismantlingId === this.state.MoreID) {
                i.more = false;
              } else {
                i.more = true;
              }
            });
          } else {
            this.state.Blocks?.mappedweights.map((i) => {
              i.more = true;
            });
          }

          this.setState({});
        } else {
        }
      })
      .catch((error) => {});
  };
  gethistorylog = (id) => {
    let apiUrl = API.HISTORY_LOG + id + "?name=DismantlingWeight";
    this.props.dispatch({ type: "SHOW_LOADER", data: true });
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        if (response?.status === 200) {
          this.props.dispatch({ type: "HISTORY_LOG", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        if (error?.response?.status === 401) {
        }
      });
  };
  Expand = (index) => {
    this.state.Blocks.mappedweights.map((i, j) => {
      if (j != index) {
        i.more = true;
      }
    });
    this.state.Blocks.mappedweights[index].more =
      !this.state.Blocks.mappedweights[index].more;
    this.setState({});
  };
  handleChangeTons = (e, index, index1) => {
    if (e.target.value == "") {
      this.state.Blocks.mappedweights[index].Weight[index1].Tons = 0;
      this.setState({});
    } else {
      this.state.Blocks.mappedweights[index].Weight[index1].Tons =
        e.target.value;
      this.setState({});
    }
  };
  saveTons = (index, index1) => {
    this.state.Blocks.mappedweights[index].Weight[index1].Tons = parseFloat(
      this.state.Blocks.mappedweights[index].Weight[index1].Tons
    );
    this.state.MoreID = this.state.Blocks.mappedweights[index].DismantlingId;
    this.state.Blocks.mappedweights[index].Weight[index1].Modify =
      localStorage.getItem("UserRoles");
    this.setState({});
    this.addTons(this.state.Blocks.mappedweights[index].Weight[index1]);
  };
  handleChangeRemark = (e, index, node) => {
    if (node == "Remark") {
      if (e.target.value.length - 1 < 500) {
        this.state.Blocks.mappedweights[index][node] = e.target.value;
        // this.setState({});
      }
    } else {
      this.state.Blocks.mappedweights[index].Remark = e.target.value;
    }
  };
  saveRemark = (e, index) => {
    this.state.MoreID = this.state.Blocks.mappedweights[index].DismantlingId;
    this.setState({});
    let data = {
      modify: localStorage.getItem("UserRoles"),
      DismantlingId: this.state.Blocks.mappedweights[index].DismantlingId,
      ProjectId: parseInt(localStorage.getItem("DashId")),
      Remarks: e.target.value.trim(),
      drawingId: this.state.Blocks.mappedweights[index].DrawingId,
    };

    this.addTons(data);
    // this.addTons(this.state.Blocks.mappedweights[index])
  };
  addTons = (data) => {
    let apiUrl = API.WEIGHTCALCULATION + "DismantlingWeight";

    this.props.dispatch({ type: "SHOW_LOADER", data: true });

    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });

        if (response?.status === 200) {
          this.getBlock1(this.state.BlockData.ProjectId);
          // this.props.navigate("/dismantlingweightcalculation")
        } else {
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        if (error?.response?.status === 401) {
        }
      });
  };
  render() {
    let { classes, menuToggle } = this.props;
    return (
      <>
        {this.state.isMobile ? (
          <>
            <div className="row w-100 mt-4">
              <div className="col-6 mt-auto">
                <List
                  className="pt-3 mt-4 pl-3"
                  style={{ backgroundColor: "#F6F6F6" }}
                >
                  <ListItem onClick={this.sidebar}>
                    <ListItemText
                      id={"WEIGHT" + "1"}
                      className="  textNaviIcon"
                      primary="Daily Tasks"
                    />
                    <NavigateNextIcon
                      id="WEIGHT"
                      className="naviIcon ml-1"
                      style={{ width: 23, height: 23 }}
                    />
                    <Divider className="border-bottom" />
                  </ListItem>
                </List>
              </div>
              <div className="col-6 pt-2 mt-5">
                <h4>Dismantling Weight Calculation </h4>
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
        <div
          className={
            this.state.isMobile
              ? "ml-auto scroll-hide border-top"
              : "ml-auto scroll-hide"
          }
          style={{
            backgroundColor: "#FFFFFF",
            width: this.state.isMobile
              ? "100%"
              : menuToggle
              ? "calc(100% - 240px)"
              : "calc(100% - 64px)",
            marginTop: this.state.isMobile ? "" : -95,
          }}
        >
          <div style={{ margin: this.state.isMobile ? "0" : "5px" }}>
            {this.state.isMobile ? (
              <></>
            ) : (
              <h6 className="col-12 mx-2 mt-3 ml-1">
                Dismantling Weight Calculation
              </h6>
            )}
            <div className="row ">
              <div>
                {this.state.isAccess ? (
                  <>
                    <AppBar
                      position="static"
                      color="inherit"
                      className={classes.root}
                    >
                      <Tabs
                        value={this.state.value}
                        onChange={this.handleChange}
                        classes={{ indicator: classes.indicator }}
                      >
                        <Tab
                          label="Total Weight"
                          className="px-1 ml-4"
                          style={{ textTransform: "none", minWidth: "13px" }}
                          {...a11yProps(0)}
                        />
                        <Tab
                          label="History log"
                          className=""
                          style={{ textTransform: "none", minWidth: "13px" }}
                          {...a11yProps(1)}
                        />
                      </Tabs>
                    </AppBar>
                  </>
                ) : (
                  <></>
                )}
                <TabPanel value={this.state.value} index={0}>
                  <div className="row" style={{ marginTop: "-10px" }}>
                    {this.state.isAccess ? (
                      <></>
                    ) : (
                      <>
                        <div>
                          <h4 className="f-size-13">Total Weight</h4>
                        </div>
                      </>
                    )}
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2">
                      <label>Total Blocks Weight :</label>
                      <label className="ml-3">
                        {this.state.Blocks.TotalBlockWeight}
                      </label>
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2">
                      <h6>Block Details and Tons</h6>
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div
                      className={this.state.isMobile ? "table-responsive" : ""}
                    >
                      <div
                        className={
                          this.state.isMobile
                            ? "col-12 col-sm-12 pb-4 col-md-12 col-lg-12 col-xl-9 mt-2 px-1"
                            : "col-12 col-sm-12 pb-4 col-md-12 col-lg-12 col-xl-9 mt-2 px-0"
                        }
                      >
                        <table className="dataTable " width="50%">
                          <thead>
                            <tr>
                              <th className="border-right border-left border-top">
                                <span
                                  className="spandoc-thead"
                                  style={{ color: "#000000" }}
                                >
                                  Blocks
                                </span>
                              </th>
                              <th className="border-right border-top">
                                <span
                                  className="spandoc-thead"
                                  style={{ color: "#000000" }}
                                >
                                  Tons
                                </span>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.Blocks?.mappedweights &&
                              this.state.Blocks?.mappedweights.map(
                                (j, index) => (
                                  <>
                                    <tr>
                                      <td className="border-right border-left spanTopBar">
                                        <span className="spanTopBar">
                                          {j.BlockNo}
                                        </span>
                                      </td>
                                      <td className="border-right spanTopBar">
                                        <span className="spanTopBar">
                                          <label>{j.Total}</label>
                                        </span>{" "}
                                        <button
                                          className={`${classes.button} float-end`}
                                          onClick={() => {
                                            this.Expand(index);
                                          }}
                                        >
                                          {" "}
                                          {j.more ? (
                                            <ExpandMore />
                                          ) : (
                                            <ExpandLess />
                                          )}
                                        </button>
                                      </td>
                                    </tr>
                                    {j.more ? (
                                      <></>
                                    ) : (
                                      <>
                                        <tr
                                          style={{ backgroundColor: "#FAFAFA" }}
                                        >
                                          <td
                                            colspan="2"
                                            className="border-left border-right"
                                          >
                                            <div
                                              style={{
                                                marginTop: "10px",
                                                width: "100%",
                                              }}
                                            >
                                              <table
                                                className="dataTable"
                                                width="100%"
                                                style={{
                                                  background: "#C4C4C4",
                                                }}
                                              >
                                                <thead>
                                                  <tr>
                                                    <th
                                                      className="border-right border-left border-top text-center"
                                                      width="5%"
                                                      style={{
                                                        minWidth: "40px",
                                                        background: "#C4C4C4",
                                                      }}
                                                    >
                                                      <span
                                                        className="spandoc-thead"
                                                        style={{
                                                          color: "#000000",
                                                        }}
                                                      >
                                                        S.No
                                                      </span>
                                                    </th>
                                                    <th
                                                      className="border-right border-top text-center"
                                                      width="70%"
                                                      style={{
                                                        minWidth: "250px",
                                                        background: "#C4C4C4",
                                                      }}
                                                    >
                                                      <span
                                                        className="spandoc-thead"
                                                        style={{
                                                          color: "#000000",
                                                        }}
                                                      >
                                                        Location
                                                      </span>
                                                    </th>
                                                    <th
                                                      className="border-right border-top text-center"
                                                      width="10%"
                                                      align="center"
                                                      style={{
                                                        minWidth: "70px",
                                                        background: "#C4C4C4",
                                                      }}
                                                    >
                                                      <span
                                                        className="spandoc-thead"
                                                        style={{
                                                          color: "#000000",
                                                        }}
                                                      >
                                                        Tons
                                                      </span>
                                                    </th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {j?.Weight &&
                                                    j?.Weight.map(
                                                      (ind, index1) => (
                                                        <>
                                                          <tr>
                                                            <td
                                                              className="border-right border-left text-center spandoc-td"
                                                              style={{
                                                                background:
                                                                  "#C4C4C4",
                                                              }}
                                                            >
                                                              <span className="spandoc-td">
                                                                {index1 + 1}
                                                              </span>
                                                            </td>
                                                            <td
                                                              align="center"
                                                              className="border-right spandoc-td"
                                                              style={{
                                                                background:
                                                                  "#C4C4C4",
                                                              }}
                                                            >
                                                              <label>
                                                                {ind.Location}
                                                              </label>
                                                            </td>
                                                            <td
                                                              className="border-right text-center spandoc-td"
                                                              style={{
                                                                background:
                                                                  "#C4C4C4",
                                                              }}
                                                            >
                                                              <div>
                                                                {this.state
                                                                  .isAccess ? (
                                                                  <>
                                                                    <CssTextFieldTons
                                                                      multiline
                                                                      fullWidth
                                                                      variant="outlined"
                                                                      value={
                                                                        ind.Tons
                                                                      }
                                                                      type="number"
                                                                      step="any"
                                                                      inputStyle={{
                                                                        textAlign:
                                                                          "center",
                                                                      }}
                                                                      onChange={(
                                                                        e
                                                                      ) =>
                                                                        this.handleChangeTons(
                                                                          e,
                                                                          index,
                                                                          index1
                                                                        )
                                                                      }
                                                                      onBlur={(
                                                                        e
                                                                      ) =>
                                                                        this.saveTons(
                                                                          index,
                                                                          index1
                                                                        )
                                                                      }
                                                                      InputProps={{
                                                                        step: "1",
                                                                        className: `border-radius padding-space1 ml-auto float-end spandoc-tbody ${classes.inputfieldAlign}`,
                                                                      }}
                                                                    />
                                                                  </>
                                                                ) : (
                                                                  <>
                                                                    <CssTextFieldTons
                                                                      multiline
                                                                      fullWidth
                                                                      variant="outlined"
                                                                      value={
                                                                        ind.Tons
                                                                      }
                                                                      type="number"
                                                                      step="any"
                                                                      inputStyle={{
                                                                        textAlign:
                                                                          "center",
                                                                      }}
                                                                      disabled
                                                                      InputProps={{
                                                                        step: "1",
                                                                        className: `border-radius padding-space1 ml-auto float-end spandoc-tbody ${classes.inputfieldAlign}`,
                                                                      }}
                                                                    />
                                                                  </>
                                                                )}
                                                              </div>
                                                            </td>
                                                          </tr>
                                                        </>
                                                      )
                                                    )}
                                                  <tr>
                                                    <td
                                                      colspan="2"
                                                      className="border-right border-left spandoc-td"
                                                      style={{
                                                        background: "#F6F6F6",
                                                      }}
                                                    >
                                                      <span
                                                        className="fw-600 f-size-12"
                                                        style={{
                                                          color: "#000000",
                                                        }}
                                                      >
                                                        Total
                                                      </span>
                                                    </td>
                                                    <td
                                                      className="border-right text-center f-size-12 fw-600"
                                                      style={{
                                                        background: "#F6F6F6",
                                                      }}
                                                    >
                                                      <span
                                                        className="f-size-12 spanTopBar  spandoc-td"
                                                        style={{
                                                          color: "#000000",
                                                        }}
                                                      >
                                                        {j.Total}
                                                      </span>
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            colspan="2"
                                            className="border-left border-right"
                                          >
                                            <div
                                              className="mt-2 d-flex px-0"
                                              style={{ margin: "5px" }}
                                            >
                                              <div className="mt-4 pt-2 px-0 col-2 text-center spandoc-td">
                                                <label>Remarks&nbsp;:</label>
                                              </div>
                                              <div className=" mt-2 col-10 pb-1 px-0">
                                                {this.state.isAccess ? (
                                                  <>
                                                    <CssTextFieldLast
                                                      multiline
                                                      fullWidth
                                                      variant="outlined"
                                                      type="text"
                                                      rows={4}
                                                      value={j.Remark}
                                                      onChange={(e) =>
                                                        this.handleChangeRemark(
                                                          e,
                                                          index,
                                                          "Remark"
                                                        )
                                                      }
                                                      onBlur={(e) =>
                                                        this.saveRemark(
                                                          e,
                                                          index
                                                        )
                                                      }
                                                      InputProps={{
                                                        className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`,
                                                      }}
                                                    />
                                                  </>
                                                ) : (
                                                  <>
                                                    <TextField
                                                      multiline
                                                      fullWidth
                                                      variant="outlined"
                                                      type="text"
                                                      disabled
                                                      rows={4}
                                                      value={j.Remark}
                                                      InputProps={{
                                                        className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`,
                                                      }}
                                                    />
                                                  </>
                                                )}

                                                <label
                                                  className="float-end pt-2"
                                                  style={{ opacity: "0.5" }}
                                                >
                                                  {j.Remark?.length == undefined
                                                    ? 500 - 0
                                                    : 500 - j.Remark?.length}
                                                  /500 Characters left
                                                </label>
                                              </div>
                                            </div>
                                          </td>
                                        </tr>
                                      </>
                                    )}
                                  </>
                                )
                              )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </TabPanel>
                <TabPanel value={this.state.value} index={1}>
                  <div className="row">
                    <div className="mt-n1">
                      <div className="col-12 col-sm-12 col-lg-8 col-xl-6 col-md-12 px-0">
                        <div
                          className="table-responsive mb-4"
                          style={{ width: "100%" }}
                        >
                          <table id="dataTable" className="table">
                            <thead>
                              <tr className="">
                                <th
                                  className="border-top border-right border-left"
                                  style={{ width: "10%", minWidth: "170px" }}
                                >
                                  <span
                                    className="spandoc-thead"
                                    style={{ color: "#000000" }}
                                  >
                                    Timestamp
                                  </span>
                                </th>
                                <th
                                  className="border-top border-right"
                                  style={{
                                    width: "6%",
                                    minWidth:
                                      window.innerWidth < 1000 ? "80px" : "",
                                  }}
                                >
                                  <span
                                    className="spandoc-thead"
                                    style={{ color: "#000000" }}
                                  >
                                    Action
                                  </span>
                                </th>
                                <th
                                  className="border-top border-right"
                                  style={{
                                    width: "15%",
                                    minWidth:
                                      window.innerWidth < 1000 ? "135px" : "",
                                  }}
                                >
                                  <span
                                    className="spandoc-thead"
                                    style={{
                                      color: "#000000",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Action by
                                  </span>
                                </th>
                              </tr>
                            </thead>
                            <tbody style={{ fontFamily: "Segoe UI" }}>
                              {this.props.historyLog &&
                                this.props.historyLog.map((i) => (
                                  <tr>
                                    <td className="spandoc-td border-right border-left align-middle Nowrap">
                                      {moment(i.TimeStamp).format(
                                        this.props.settings.Convention
                                          ? this.props.settings.Convention +
                                              " hh:mm:ss A"
                                          : "DD/MM/YYYY hh:mm:ss A"
                                      )}
                                    </td>
                                    <td className="spandoc-td border-right align-middle">
                                      {i.Action}
                                    </td>
                                    <td className="spandoc-td border-right align-middle">
                                      {i.ActionBy}
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </TabPanel>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

function mapStateToProps(state) {
  return {
    menuToggle: state.commonReducer.menuToggle,
    historyLog: state.commonReducer.historyLog || [],
    weight: state.commonReducer.weight || [],
    settings: state.commonReducer.settings || [],
  };
}

ListViewDISWC.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(styles)(ListViewDISWC))
);
